import { Dispatch } from '@reduxjs/toolkit'
import { claimRecordsApi } from '@redux/queries/claimRecords'
import { setClaimRecordDeleted } from '@redux/slices/claimStatusSlice'

export const resetClaimRecordState = (dispatch: Dispatch) => {
  dispatch(setClaimRecordDeleted())
  dispatch(claimRecordsApi.util.resetApiState())
}
